import React from 'react';

const TripTypeTabs = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    <button
      type="button"
      className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${
        value === 'ONEWAY' ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-600'
      }`}
      onClick={() => onChange('ONEWAY')}
    >
      One way
    </button>
    <button
      type="button"
      className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${
        value === 'ROUNDTRIP' ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-600'
      }`}
      onClick={() => onChange('ROUNDTRIP')}
    >
      Round trip
    </button>
  </div>
);

export default TripTypeTabs;
